/**
 * @generated SignedSource<<38959b040493ae443d44956672ddcf8e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StoreSuperAdminPanelCreateOrgMutation$variables = {
  email: string;
  orgName: string;
};
export type StoreSuperAdminPanelCreateOrgMutation$data = {
  readonly _adminCreateOrg: boolean;
};
export type StoreSuperAdminPanelCreateOrgMutation = {
  response: StoreSuperAdminPanelCreateOrgMutation$data;
  variables: StoreSuperAdminPanelCreateOrgMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "email"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orgName"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "orgName"
      }
    ],
    "kind": "ScalarField",
    "name": "_adminCreateOrg",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StoreSuperAdminPanelCreateOrgMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StoreSuperAdminPanelCreateOrgMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "4a1946dc384991684d05f72cfc5b2603",
    "id": null,
    "metadata": {},
    "name": "StoreSuperAdminPanelCreateOrgMutation",
    "operationKind": "mutation",
    "text": "mutation StoreSuperAdminPanelCreateOrgMutation(\n  $orgName: String!\n  $email: String!\n) {\n  _adminCreateOrg(email: $email, name: $orgName)\n}\n"
  }
};
})();

(node as any).hash = "efbe2fa55359109267031b8b5ef4f442";

export default node;
